const PROVENANCE_LABELS_PT = {
    self_declared: 'autodeclarado',
    verified: 'verificado',
};
/**
 * DD/MM a partir de um ISO 8601 — UTC-safe simples (convenção do resto do
 * shared). F4 (Nit, revisão adversarial Fase 4 fix wave) — `entry` é
 * passthrough de Json (`Appointment.collectedData`); nada garante em
 * RUNTIME que os campos batem com o shape TS (dado legado/malformado).
 * Parâmetro `unknown` (não `string`) é deliberado: aceita o valor cru sem
 * o TS "confiar" que já é válido. `null` (em vez de propagar "NaN/NaN")
 * quando ausente ou com data inválida — o caller omite a parte da data.
 */
function formatDayMonthSafe(iso) {
    if (typeof iso !== 'string')
        return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return null;
    const day = d.getUTCDate().toString().padStart(2, '0');
    const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}`;
}
/**
 * F4 — mesma defesa de runtime que `formatDayMonthSafe`: proveniência
 * ausente/vazia → `null` (o caller OMITE a proveniência; nunca inventa um
 * default tipo "autodeclarado" para dado que não a declara).
 */
function describeProvenance(provenance) {
    if (typeof provenance !== 'string' || provenance.length === 0)
        return null;
    return PROVENANCE_LABELS_PT[provenance] ?? provenance;
}
function formatValue(value) {
    if (typeof value === 'string')
        return value;
    if (value === null || value === undefined)
        return '';
    if (typeof value === 'number' || typeof value === 'boolean')
        return String(value);
    try {
        return JSON.stringify(value);
    }
    catch {
        return '';
    }
}
/**
 * Formata um campo coletado do episódio para exibição (Drawer web §3.3 /
 * DetailSheet mobile §3.4). Pura — nenhum acesso a rede/estado.
 *
 * Regras da meta (spec §3.3):
 * - `confirmedAt` presente → `confirmado em DD/MM · da última vez` (o
 *   `carriedFromAppointmentId` já é comunicado por essa frase — sem sufixo
 *   extra quando presente; sem `carriedFromAppointmentId` mas com
 *   `confirmedAt` → só `confirmado em DD/MM`).
 * - Sem `confirmedAt` → `coletado em DD/MM · <proveniência>` (proveniência
 *   mapeada PT-BR; desconhecida sai literal).
 *
 * F4 (Nit, revisão adversarial Fase 4 fix wave) — fallbacks honestos: data
 * ausente/inválida OMITE a parte "em DD/MM" (nunca "NaN/NaN"); proveniência
 * ausente OMITE a parte "· <proveniência>" (nunca inventa um default).
 */
export function describeCollectedField(name, entry) {
    const value = formatValue(entry.value);
    if (entry.confirmedAt !== undefined) {
        const day = formatDayMonthSafe(entry.confirmedAt);
        const suffix = entry.carriedFromAppointmentId !== undefined ? ' · da última vez' : '';
        const meta = day !== null ? `confirmado em ${day}${suffix}` : `confirmado${suffix}`;
        return { label: name, value, meta };
    }
    const day = formatDayMonthSafe(entry.collectedAt);
    const provenance = describeProvenance(entry.provenance);
    const base = day !== null ? `coletado em ${day}` : 'coletado';
    const meta = provenance !== null ? `${base} · ${provenance}` : base;
    return { label: name, value, meta };
}
//# sourceMappingURL=envelope.js.map